const getEnv = () => {
  const hostConfig = {
    canary: ['one-test.wywk.cn/'],
    uat: ['one-uat.wywk.cn'],
    prod: ['one.wywk.cn'],
  };

  const host = document.domain.toLowerCase();
  let env = 'dev';

  if (hostConfig.canary.includes(host)) {
    env = 'canary';
  } else if (hostConfig.uat.includes(host)) {
    env = 'uat';
  } else if (hostConfig.prod.includes(host)) {
    env = 'prod';
  }

  return env;
};

export default getEnv;
